// extracted by mini-css-extract-plugin
export var deleteModal = "_r0-0";